<mat-dialog-content class="mat-typography content-modal">
    <div class="ds-flex-between">
        <div class="ds-flex-align-center">
            <img class="margin-right-2" src="../../../../../assets/img/icon/warning-alert.svg">
            <div>Es obligatorio especificar el motivo de rechazo para cada pago.</div>
        </div>
        <img class="pointer margin-left-2" src="../../../../../assets/img/icon/cancel-alert.svg" (click)="close()">
    </div>
</mat-dialog-content>